import { useIsMobileSize } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Table, TableMobile } from 'libs/ui';

import { useOrderContext } from '../../providers/OrderProvider';

import { useColumns } from './columns';
import { useMobileColumns } from './columnsMobile';

export const OperationsTable = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobileSize();
  const { order, brokerTimezoneOffset } = useOrderContext();

  const columns = useColumns({ brokerTimezoneOffset });
  const columnsMobile = useMobileColumns({ brokerTimezoneOffset });

  if (!order) {
    return null;
  }

  return isMobile ? (
    <TableMobile
      separatedRows
      columns={columnsMobile}
      labelsColumnMinWidth={160}
      rows={order.operations ?? []}
    />
  ) : (
    <Table
      columns={columns}
      noRowsProps={{
        title: t('common.noRows'),
      }}
      rowCount={order.operations?.length ?? 0}
      rowHeight={62}
      rows={order.operations ?? []}
      styleVariant="outline"
    />
  );
};
